/**
 * TutorManageSessionScreen — « Gérer une séance » (`move-session?liveId=`), ouvert en touchant une
 * séance sans demande (« Ma journée », la semaine). La feuille d'étapes du design system, ouverte sur
 * la route, par-dessus l'écran d'où vient le tuteur (`tutorSpaceRouteOptions`, lu par la table des
 * routes) : pas sur une page vide. Un fil : le view-model, les lectures, les gestes, le gabarit.
 */
import React from "react"
import { useSelector } from "react-redux"

import { TutorManageSessionFlow } from "../../../../../../design-system/tutor"
import { tutorManageSessionViewModel } from "../../../../view-models/tutor/Lives/tutorManageSessionViewModel"
import { type TutorSpaceScreenProps } from "../tutorSpaceRouteTypes"
import { useTutorManageSessionData } from "./useTutorManageSessionData"
import { useTutorManageSessionState } from "./useTutorManageSessionState"

export function TutorManageSessionScreen({ route }: TutorSpaceScreenProps) {
    const liveId = route?.params?.liveId ?? null
    const dateTime = route?.params?.dateTime ?? null
    const vm = useSelector((state: unknown) => tutorManageSessionViewModel(state, { liveId, dateTime }))
    const reads = useTutorManageSessionData(liveId, vm.managed?.isIndividual ?? false)
    const flow = useTutorManageSessionState(vm, reads)

    if (flow == null) return null
    return <TutorManageSessionFlow {...flow} testID="tutor-manage-session" />
}
